export default __webpack_public_path__ + "static/media/icons8-telegram-app.b0589b5e.svg";